<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!--for overlay :loading="get_ay_std_ft_loader" -->
    <!--api- 1  -->
    <v-card v-if="ay_std_data != null" class="no-display box">
      <v-toolbar flat class="toolbar" dense align="center" justify="center">
        <v-toolbar-title>Roll Call</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <!-- <v-row justify="center">
                    <v-col sm="3">
                        <h3>Roll Call</h3>
                    </v-col>
                </v-row> -->
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox color="#0F2027" rounded dense required v-model="current_academic_year"
              :items="ay_std_data.academic_year_list" item-text="Academic Year" label="Academic Year" outlined />
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox color="#0F2027" rounded dense required v-model="std" :items="ay_std_data.standard_list"
              item-text="Standard" label="Standard" outlined />
          </v-col>
          <v-col sm="2" v-if="division_list != null">
            <v-icon color="error">*</v-icon>
            <v-combobox color="#0F2027" rounded dense required v-model="division" :items="division_list"
              item-text="divname" label="Division" outlined />
          </v-col>
          <v-col sm="2" v-if="division != null">
            <v-icon color="error">*</v-icon>
            <v-combobox color="#0F2027" rounded dense required v-model="report_type" :items="report_type_list"
              item-text="name" label="Report" outlined />
          </v-col>
          <v-col cols="12" sm="2" md="2" v-if="division != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
              item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
          </v-col>
          <v-col sm="2" v-if="report_type != null && stud_status != ''">
            <v-btn class="mt-6 button" @click="getReport" :loading="fetch_btn_load">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <br />
    <!-- api-1 ends -->
    <!-- api-3 -->

    <v-card class="box" v-if="records.length != 0">
      <v-toolbar flat class="toolbar" dense align="center" justify="center">
        <v-toolbar-title>Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
            class="no-display"></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-btn class="ma-2 no-display" rounded outlined color="warning" @click="print()">
            <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
          </v-btn>
        </v-col>
        <!-- <v-col cols="12" sm="2" md="2">
          <download-excel
            v-if="records.length != 0"
            color="primary"
            dark
            :data="records"
            :fields="xls_header"
            worksheet="My Worksheet"
            name="filename.xls"
            :title="xls_title"
          >
            <v-btn rounded class="ma-2 no-display" outlined color="success">
              <v-icon left>mdi-file-excel</v-icon> Excel
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </download-excel>
        </v-col> -->

        <!-- export btn code -->

        <v-col cols="6" sm="2" md="2">
          <v-btn class="ma-2 no-display " rounded color="success" outlined v-if="filtered_div_list != 0"
            @click="fnExcelReport('my-table-id', 'RollCall')" :loading="loader"><v-icon
              color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
        <!-- export btn code end-->
      </v-row>
      <!-- disable-pagination hide-default-footer -->
      <div id="my-table-id">
        <v-data-table id="print" :headers="header_list" :items="records" sort-by class="elevation-1 mytable"
          :search="search" :items-per-page="-1">
          <template v-slot:top>
            <v-row justify="center" class="ma-2 table-sub-title">
              AY:{{ current_academic_year }} || STD:{{ std }} || Div:{{
              division.divname
              }}
            </v-row>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    status_list: [],
    stud_status: null,

    // extraBreadcrumbItems: [
     

    // ],
    breadcrumbClass: "breadcrumb-style1",
    report_type_list: [
      { name: "Roll", link: "getRollCall" },
      // { name: "Fees Due", link: "getFeesDue" },
    ],
    report_type: null,
    //1
    search: "",
    ay_std_data: null,
    fetch_btn_load: false,
    std: null,
    current_academic_year: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    //2
    division_list: null,
    division: null,
    fetch_btn_load: false,
    //3
    header_list: [],
    records: [],
    query: { limit: 10, offset: 0, sort: "", order: "" },
    xls_header: [],
    xls_title: [],
    printing: null,
  }),
  watch: {
    std() {
      this.getDivOff();
    },
    current_academic_year() {
      this.getDivOff();
    },
  },
  methods: {
    fnExcelReport(id, name) {
      let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Roll No</th>
      <th>PRN No</th>
      <th>Name</th>
      <th>First Name</th>
      <th>Middle Name</th>
      <th>Last Name</th>
      <th>Contact</th>
      <th>Gender</th>
      
    </tr>`;

      this.records.forEach((item, index) => {
        tab_text += `
    <tr>
       
      <td>${index + 1}</td>
        <td>${item.rollno || ''}</td>
        <td>${item.grno || ''}</td>
        <td>${item.name || ''}</td>
        <td>${item.firstname || ''}</td>
        <td>${item.middlename || ''}</td>
        <td>${item.lastname || ''}</td>
        <td>${item.contact || ''}</td>
        <td>${item.gender || ''}</td>
        
    </tr>`;
      });

      tab_text += '</table>';

      const blob = new Blob([tab_text], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onbeforeprint = function () {
        that.$store.state.drawer = false;
      };
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    getReport() {
      //api-3
      this.fetch_btn_load = true;
      this.records = [];
      this.header_list = [];
      this.xls_header = [];
      this.xls_title = [];
      const data = {
        id: this.division.id,
        stud_status: this.stud_status.id,
      };
      axios
        .post("/admissionReport/" + this.report_type.link, data)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "YES") {
              this.records = res.data.records;
              this.header_list = res.data.header_list;
              this.xls_header = res.data.xls_header;
              this.xls_title.push(this.report_type.name);
              this.xls_title.push(
                "AY:" +
                this.current_academic_year +
                "   Standard:" +
                this.std +
                "   Div:" +
                this.division.divname
              );
              if (this.records.length <= 0) {
                this.showSnackbar("#b71c1c", "Student not found!!!");
              }
            } else {
              this.showSnackbar("#b71c1c", "Student not found!!!");
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.fetch_btn_load = false;
        });
    },
    getDivOff() {
      //api-2
      //erase for api-3
      this.records = [];
      this.header_list = [];
      this.xls_header = [];
      //ends
      this.division_list = null;
      this.division = null;
      this.report_type = null;

      if (this.std != null && this.current_academic_year != null) {
        const formData = {
          std: this.std,
          ay: this.current_academic_year,
        };
        axios
          .post("/admissionReport/getDivOff", formData)
          .then((res) => {
            if (res.data.msg == "200") {
              this.division_list = res.data.division_list;
              if (this.division_list.length == 0) {
                this.showSnackbar("#b71c1c", "Division not offered!!!");
                this.division_list = null;
              }
            } else {
              //error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            //close loader
          });
      }
    },
    get_ay_std() {
      //api-1
      axios
        .post("/feesMaster/get_ay_std_ft")
        .then((res) => {
          if (res.data.msg == "200") {
            this.ay_std_data = res.data.fees_structure_data;
            this.current_academic_year =
              res.data.fees_structure_data.current_academic_year;
            this.status_list = res.data.status_list;
            this.stud_status = this.status_list[1];
            // this.report_type_list=res.data.report_type_list;
            // this.report_type=this.report_type_list[0];
            //this.std = this.ay_std_data.standard_list[0];
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.get_ay_std();
  },
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}

.allot-btn:hover .allot-icon {
  color: white;
}

.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}

.table-sub-title {
  margin-left: 1%;
  font-weight: 500;
  color: #999;
}

@media print {
  body {
    height: 100%;
    width: 100%;
  }

  .no-display {
    display: none !important;
  }

  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }

  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}
</style>
